import { render, staticRenderFns } from "./ResaleCertificatesManager.vue?vue&type=template&id=76089778&scoped=true&"
import script from "./ResaleCertificatesManager.vue?vue&type=script&lang=js&"
export * from "./ResaleCertificatesManager.vue?vue&type=script&lang=js&"
import style0 from "./ResaleCertificatesManager.vue?vue&type=style&index=0&id=76089778&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76089778",
  null
  
)

export default component.exports